export function initValue(value) {
    if (!value || typeof value !== "string") {
        return "";
    }
    return value;
}